import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { selectSelectedComponent, updateComponent } from '../../../redux/editorSlice';
import { PaddingControl, BorderRadiusControl, StyleControl, SkinSelector } from '../CommonProperties';

const ProductSliderProperties = () => {
  const selectedComponent = useSelector(selectSelectedComponent);
  const dispatch = useDispatch();
  
  // 컴포넌트 속성 변경 핸들러
  const handleComponentPropsChange = (property, value) => {
    const existingProps = JSON.parse(JSON.stringify(selectedComponent.componentProps || {}));
    existingProps[property] = value;
    
    dispatch(updateComponent({
      id: selectedComponent.id,
      changes: {
        componentProps: existingProps
      }
    }));
  };

  return (
    <>
      {/* 스킨 선택 */}
      <SkinSelector
        selectedComponent={selectedComponent}
        onSkinChange={(skinId) => handleComponentPropsChange('skin', skinId)}
      />

      <div className="property-group">
        <div className="property-group-title">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="3" y="3" width="18" height="18" rx="2" stroke="currentColor" strokeWidth="2" />
            <path d="M7 7H17" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
            <path d="M7 12H17" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
            <path d="M7 17H12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
          </svg>
          슬라이더 설정
        </div>
        
        {/* 슬라이더 타이틀 설정 */}
        <div className="property-row">
          <label style={{ minWidth: '30%' }}>슬라이더 타이틀</label>
          <input 
            type="text"
            value={selectedComponent.componentProps?.sliderTitle || '인기 상품'}
            onChange={(e) => handleComponentPropsChange('sliderTitle', e.target.value)}
            style={{ width: '100%' }}
          />
        </div>
        
        {/* 타이틀 표시 여부 */}
        <div className="property-row">
          <label style={{ minWidth: '30%' }}>타이틀 표시</label>
          <div className="custom-toggle-switch">
            <input 
              type="checkbox" 
              id="toggle-slider-title"
              checked={selectedComponent.componentProps?.showTitle !== false}
              onChange={(e) => handleComponentPropsChange('showTitle', e.target.checked)}
            />
            <label htmlFor="toggle-slider-title" className="toggle-switch-label">
              <span className="toggle-track"></span>
            </label>
          </div>
        </div>
        
        {/* 타이틀 글자 크기 */}
        <div className="property-row">
          <label style={{ minWidth: '30%' }}>타이틀 글자 크기</label>
          <div className="input-with-unit">
            <input 
              type="text" 
              value={(selectedComponent.componentProps?.titleFontSize || '18px').replace('px', '')}
              onChange={(e) => handleComponentPropsChange('titleFontSize', `${e.target.value}px`)}
              style={{ width: '50px' }}
            />
            <span>px</span>
          </div>
        </div>
        
        {/* 타이틀 색상 */}
        <div className="property-row">
          <label style={{ minWidth: '30%' }}>타이틀 색상</label>
          <input 
            type="color"
            value={selectedComponent.componentProps?.titleColor || '#333333'}
            onChange={(e) => handleComponentPropsChange('titleColor', e.target.value)}
          />
        </div>
        
        
        
        <div className="property-row">
          <label style={{ minWidth: '30%' }}>자동 슬라이드</label>
          <div className="custom-toggle-switch">
            <input 
              type="checkbox" 
              id="toggle-auto-slide" 
              checked={selectedComponent.componentProps?.autoSlide !== false}
              onChange={(e) => handleComponentPropsChange('autoSlide', e.target.checked)}
            />
            <label htmlFor="toggle-auto-slide" className="toggle-switch-label">
              <span className="toggle-track"></span>
            </label>
          </div>
        </div>
        
        {selectedComponent.componentProps?.autoSlide !== false && (
          <div className="property-row">
            <label style={{ minWidth: '30%' }}>자동 슬라이드 간격</label>
            <select 
              value={selectedComponent.componentProps?.autoSlideInterval || 5000}
              onChange={(e) => handleComponentPropsChange('autoSlideInterval', parseInt(e.target.value))}
              style={{ width: '70%' }}
            >
              <option value="2000">2초</option>
              <option value="3000">3초</option>
              <option value="4000">4초</option>
              <option value="5000">5초</option>
              <option value="7000">7초</option>
              <option value="10000">10초</option>
            </select>
          </div>
        )}
      </div>
      
      <div className="property-group">
        <div className="property-group-title">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="3" y="3" width="18" height="18" rx="2" stroke="currentColor" strokeWidth="2" />
            <path d="M3 9H21" stroke="currentColor" strokeWidth="2" />
            <path d="M9 9V21" stroke="currentColor" strokeWidth="2" />
            <path d="M15 9V21" stroke="currentColor" strokeWidth="2" />
          </svg>
          필터링 설정
        </div>
        
        <div className="property-row">
          <label style={{ minWidth: '30%' }}>포함할 상품 ID</label>
          <input 
            type="text" 
            value={selectedComponent.componentProps?.include_product_ids || ''}
            onChange={(e) => handleComponentPropsChange('include_product_ids', e.target.value)}
          />
          <div className="help-text" style={{ fontSize: '11px', color: '#666', marginTop: '2px' }}>
            쉼표로 구분하여 입력 (예: 73,74,75)
          </div>
        </div>
        
        <div className="property-row">
          <label style={{ minWidth: '30%' }}>제외할 상품 ID</label>
          <input 
            type="text" 
            value={selectedComponent.componentProps?.exclude_product_ids || ''}
            onChange={(e) => handleComponentPropsChange('exclude_product_ids', e.target.value)}
          />
          <div className="help-text" style={{ fontSize: '11px', color: '#666', marginTop: '2px' }}>
            쉼표로 구분하여 입력 (예: 74,76)
          </div>
        </div>
        
        <div className="property-row">
          <label style={{ minWidth: '30%' }}>포함할 카테고리 ID</label>
          <input 
            type="text" 
            value={selectedComponent.componentProps?.include_category_ids || ''}
            onChange={(e) => handleComponentPropsChange('include_category_ids', e.target.value)}
          />
          <div className="help-text" style={{ fontSize: '11px', color: '#666', marginTop: '2px' }}>
            쉼표로 구분하여 입력 (예: 14,8)
          </div>
        </div>
        
        <div className="property-row">
          <label style={{ minWidth: '30%' }}>제외할 카테고리 ID</label>
          <input 
            type="text" 
            value={selectedComponent.componentProps?.exclude_category_ids || ''}
            onChange={(e) => handleComponentPropsChange('exclude_category_ids', e.target.value)}
          />
          <div className="help-text" style={{ fontSize: '11px', color: '#666', marginTop: '2px' }}>
            쉼표로 구분하여 입력 (예: 16,17)
          </div>
        </div>
      </div>

      {/* 표시 옵션 설정 */}
      <div className="property-group">
        <div className="property-group-title">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 2L2 7V17L12 22L22 17V7L12 2Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
          표시 옵션
        </div>
        
        <div className="property-row">
          <label style={{ minWidth: '30%' }}>슬라이드당 상품 수</label>
          <input 
            type="number" 
            min="1"
            max="6"
            value={selectedComponent.componentProps?.itemsPerSlide || 4}
            onChange={(e) => handleComponentPropsChange('itemsPerSlide', parseInt(e.target.value) || 4)}
          />
        </div>
        
        <div className="property-row">
          <label style={{ minWidth: '30%' }}>가격 표시</label>
          <div className="custom-toggle-switch">
            <input 
              id="toggle-show-price"
              type="checkbox" 
              checked={selectedComponent.componentProps?.showPrice !== false}
              onChange={(e) => handleComponentPropsChange('showPrice', e.target.checked)}
            />
            <label htmlFor="toggle-show-price" className="toggle-switch-label">
              <span className="toggle-track"></span>
            </label>
          </div>
        </div>
        
        <div className="property-row">
          <label style={{ minWidth: '30%' }}>재고 정보 표시</label>
          <div className="custom-toggle-switch">
            <input 
              id="toggle-stock-slider"
              type="checkbox" 
              checked={selectedComponent.componentProps?.showStock === true}
              onChange={(e) => handleComponentPropsChange('showStock', e.target.checked)}
            />
            <label htmlFor="toggle-stock-slider" className="toggle-switch-label">
              <span className="toggle-track"></span>
            </label>
          </div>
        </div>
        
        <div className="property-row">
          <label style={{ minWidth: '30%' }}>장바구니 버튼</label>
          <div className="custom-toggle-switch">
            <input 
              id="toggle-show-cart"
              type="checkbox" 
              checked={selectedComponent.componentProps?.showAddToCart !== false}
              onChange={(e) => handleComponentPropsChange('showAddToCart', e.target.checked)}
            />
            <label htmlFor="toggle-show-cart" className="toggle-switch-label">
              <span className="toggle-track"></span>
            </label>
          </div>
        </div>
        
        <div className="property-row">
          <label style={{ minWidth: '30%' }}>네비게이션 버튼</label>
          <div className="custom-toggle-switch">
            <input 
              id="toggle-navigation"
              type="checkbox" 
              checked={selectedComponent.componentProps?.showNavigation !== false}
              onChange={(e) => handleComponentPropsChange('showNavigation', e.target.checked)}
            />
            <label htmlFor="toggle-navigation" className="toggle-switch-label">
              <span className="toggle-track"></span>
            </label>
          </div>
        </div>
        
        <div className="property-row">
          <label style={{ minWidth: '30%' }}>페이지네이션</label>
          <div className="custom-toggle-switch">
            <input 
              id="toggle-pagination"
              type="checkbox" 
              checked={selectedComponent.componentProps?.showPagination !== false}
              onChange={(e) => handleComponentPropsChange('showPagination', e.target.checked)}
            />
            <label htmlFor="toggle-pagination" className="toggle-switch-label">
              <span className="toggle-track"></span>
            </label>
          </div>
        </div>
      </div>

      {/* 스타일 설정 */}
      <div className="property-group">
        <div className="property-group-title">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 2L2 7V17L12 22L22 17V7L12 2Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
          스타일 설정
        </div>
        
        <div className="property-row">
          <label>가격 색상</label>
          <input 
            type="color" 
            value={selectedComponent.componentProps?.priceColor || '#ff6b6b'}
            onChange={(e) => handleComponentPropsChange('priceColor', e.target.value)}
            style={{ width: '100%', height: '32px' }}
          />
        </div>
        
        <div className="property-row">
          <label>장바구니 버튼 색상</label>
          <input 
            type="color" 
            value={selectedComponent.componentProps?.cartButtonColor || '#007bff'}
            onChange={(e) => handleComponentPropsChange('cartButtonColor', e.target.value)}
            style={{ width: '100%', height: '32px' }}
          />
        </div>
        
        <div className="property-row">
          <label>네비게이션 색상</label>
          <input 
            type="color" 
            value={selectedComponent.componentProps?.navigationColor || '#333333'}
            onChange={(e) => handleComponentPropsChange('navigationColor', e.target.value)}
            style={{ width: '100%', height: '32px' }}
          />
        </div>
        
        <div className="property-row">
          <label>페이지네이션 색상</label>
          <input 
            type="color" 
            value={selectedComponent.componentProps?.paginationColor || '#007bff'}
            onChange={(e) => handleComponentPropsChange('paginationColor', e.target.value)}
            style={{ width: '100%', height: '32px' }}
          />
        </div>
      </div>
      
      {/* <PaddingControl />
      <BorderRadiusControl />
      <StyleControl /> */}
    </>
  );
};

export default ProductSliderProperties;
